import React from "react";
import { Helmet } from "react-helmet";
import { Box } from "grid-styled";
import { Field, reduxForm } from "redux-form";
import { getPasswordResetRequest, resetPassword } from "../api";
import { InputContainer } from "./forms";
import Button, { LinkButton } from "./Button";
import LoginWrapper from "./LoginWrapper";
import CenteredLoader from "./CenteredLoader";

const isEmpty = value =>
  typeof value === "undefined" ||
  (typeof value === "string" && value.trim() === "");

const validate = values => {
  const errors = {};

  if (isEmpty(values.password)) {
    errors.password = "Please enter a new password.";
  } else if (values.password !== values.passwordConfirmation) {
    errors.passwordConfirmation = "Passwords do not match.";
  }

  return errors;
};

class ResetPassword extends React.Component {
  state = {
    fetching: false,
    existingUser: false,
    fetchingError: null,
    submitting: false,
    submitted: false,
    submittingError: null
  };

  componentDidMount() {
    const { match: { params: { token } } } = this.props;
    this.setState({ fetching: true });
    getPasswordResetRequest(token)
      .then(data => {
        this.setState({ existingUser: data.user });
      })
      .catch(err => {
        this.setState({ fetchingError: err });
      })
      .then(() => {
        this.setState({ fetching: false });
      });
  }

  onSubmit = ({ password }) => {
    const { match: { params: { token } } } = this.props;
    this.setState({ submitting: true });
    resetPassword(token, password)
      .then(() => {
        this.setState({ submitted: true });
      })
      .catch(error => {
        console.error(
          "There was a problem submitting the password reset request",
          error
        );
        this.setState({ submitted: false, error });
      })
      .then(() => this.setState({ submitting: false }));
  };

  render() {
    const { handleSubmit } = this.props;
    const {
      fetching,
      fetchingError,
      existingUser,
      submitting,
      submitted
    } = this.state;

    if (fetching) {
      return <CenteredLoader />;
    }

    if (fetchingError) {
      return (
        <LoginWrapper>
          <Box pb={2}>
            The provided password reset token doesn't exist or has expired.
          </Box>
          <LinkButton variant="primary" to="/login">
            Return to Login
          </LinkButton>
        </LoginWrapper>
      );
    }

    if (submitted) {
      return (
        <LoginWrapper>
          <Box pb={2}>Your password has been reset!</Box>
          <LinkButton variant="primary" to="/login">
            Return to Login
          </LinkButton>
        </LoginWrapper>
      );
    }

    return (
      <LoginWrapper>
        <Helmet>
          <title>Reset Password</title>
        </Helmet>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <p>
            Resetting password for <b>{existingUser.email}</b>.
          </p>
          <Box pb={2}>
            <Field
              size="large"
              name="password"
              type="password"
              labelText="Password"
              placeholder="e.g., •••••••••"
              component={InputContainer}
            />
          </Box>
          <Box pb={2}>
            <Field
              size="large"
              name="passwordConfirmation"
              type="password"
              labelText="Confirm Password"
              placeholder="e.g., •••••••••"
              component={InputContainer}
            />
          </Box>
          <Button primary type="submit" disabled={submitting}>
            {submitting ? "Resetting..." : "Reset Password"}
          </Button>
        </form>
      </LoginWrapper>
    );
  }
}

export default reduxForm({
  form: "reset-password-request",
  validate
})(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js